import { registerStoreItem } from 'utils/storeCreator'
import { thankrate } from 'api/qingsu'

const store = registerStoreItem({
  store: {
    namespaced: true,
    state: {
      heartData: [],
      is_show_rate: 0 //1为显示用户心声
    },
    mutations: {
      heartList(state, payload) {
        state.heartData = payload.thank_rate
        state.is_show_rate = payload.is_show_rate
      }
    },
    actions: {
      async qingsuHeartList({ commit }, data) {
        try {
          const res = await thankrate(data)
          if (res.code == 0) {
            commit('heartList', res.data)
            return Promise.resolve(res.data)
          } else {
            commit('heartList', '')
            return Promise.resolve('')
          }
        } catch (error) {
          commit('heartList', '')
          return Promise.resolve('')
        }
      }
    }
  },
  name: 'qingsuheart',
  api: thankrate,
  handle: data => {
    return data
  },
  defaultValue: {}
})

export default {
  name: 'qingsuHeart',
  store
}
